import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const SUPPORTED = ['nl', 'en', 'es'];

const detectLanguage = (): string => {
  // 1. URL query param: ?lang=nl
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');
    if (urlLang && SUPPORTED.includes(urlLang)) {
      localStorage.setItem('zpiritualz_lang', urlLang);
      return urlLang;
    }
  } catch (_) { /* ignore */ }

  // 2. localStorage
  try {
    const saved = localStorage.getItem('zpiritualz_lang');
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (_) { /* ignore */ }

  // 3. Browser language
  const browserLang = navigator.language?.slice(0, 2).toLowerCase();
  if (browserLang && SUPPORTED.includes(browserLang)) return browserLang;

  // 4. Default: Nederlands
  return 'nl';
};

const detectedLang = detectLanguage();

// Set html lang attribute for SEO
document.documentElement.lang = detectedLang;

i18n
  .use(initReactI18next)
  .init({
    lng: detectedLang,
    fallbackLng: 'nl',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
